export default () => ({
	legacy: false,
	availableLocales: ["de", "en"],
	missing: (_locale, key, vm) => {
		if (key.endsWith(".default")) return key;
		const keyToFind = `${key}.default`;
		try {
			const res = vm?.appContext?.app?.$nuxt?.$i18n?.t(keyToFind);
			if (res !== keyToFind) {
				return res;
			}
			vm?.appContext?.app?.$nuxt?.hooks?.callHook("app:error", new Error(`Missing translation in locale '${_locale}' for key: '${key}'`));
			return key;
		} catch {
			vm?.appContext?.app?.$nuxt?.hooks?.callHook("app:error", new Error(`Missing translation in locale '${_locale}' for key: '${key}'`));
		}
		return key;
	}
});
